import { render, staticRenderFns } from "./FixBottom.vue?vue&type=template&id=5637f36b&scoped=true&"
import script from "./FixBottom.vue?vue&type=script&lang=js&"
export * from "./FixBottom.vue?vue&type=script&lang=js&"
import style0 from "./FixBottom.vue?vue&type=style&index=0&id=5637f36b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637f36b",
  null
  
)

export default component.exports